module.exports = __webpack_public_path__ + "img/statistics_icon4.02c4514a.png";